import { render, staticRenderFns } from "./RelatorioFinanceiro.vue?vue&type=template&id=4b4c1b7e"
import script from "./RelatorioFinanceiro.vue?vue&type=script&lang=js"
export * from "./RelatorioFinanceiro.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFinanceiro.vue?vue&type=style&index=0&id=4b4c1b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports